import { AfterViewInit, Component, Input, OnInit, QueryList, ViewChildren } from "@angular/core";
import { LiabilityAndPhysicalDamageFormGroup } from "./LiabilityAndPhysicalDamageFormGroup";
import { ServiceLayer } from "src/app/services/serviceLayer";

@Component({
    selector: 'liability-and-physical-damage',
    templateUrl: './liability-and-physical-damage.component.html'
})

export class LiabilityAndPhysicalDamageComponent implements OnInit, AfterViewInit {
    @Input() lossInfoGridFormGroup: LiabilityAndPhysicalDamageFormGroup;
    @Input() isSubmitted: boolean;
    @ViewChildren('effectiveDates') effectiveDates: QueryList<any>;

    constructor(private serviceLayer: ServiceLayer) { }

    public ngOnInit(): void {
    }

    public ngAfterViewInit(): void {
        setTimeout(() => {
            this.effectiveDates?.first?.inputfieldViewChild.nativeElement.focus();
        }, 0);
    }

    public numbersOnly(event: Event): boolean {
        return this.serviceLayer.numbersOnly(event, 'loss');
    }
}